import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Device, Group, Pageable} from 'src/app/models';

@Injectable({
    providedIn: 'root'
})
export class DevicesService {
    url = '/api/v1/devices';

    constructor(public http: HttpClient) {
    }

    getDevicesByName(name: string): Observable<Device[]> {
        name = encodeURIComponent(name);
        return this.http.get<Device[]>(`${this.url}?identifier=${name}`)
            .pipe(map(devicesPage => devicesPage['content']));
    }

    getAllDevicesByName(name: string, active: string): Observable<Device[]> {
        name = encodeURIComponent(name);
        return this.http.get<Device[]>(`${this.url}?identifier=${name}&activity=${active}`)
            .pipe(map(devicesPage => devicesPage['content']));
    }

    getDevicesByNamePage(name: string, page: number): Observable<Device[]> {
        name = encodeURIComponent(name);
        return this.http.get<Device[]>(`${this.url}?identifier=${name}&size=${page}`);
    }

    getDevicesByIdentifierIgnoreWhitespace(identifier: string): Observable<Device[]> {
        identifier = encodeURIComponent(identifier);
        return this.http.get<Device[]>(`${this.url}/ignorewhitespace?identifier=${identifier}`)
            .pipe(map(devicesPage => devicesPage['content']));
    }

    getDevice(id: number): Observable<Device> {
        return this.http.get<Device>(`${this.url}/${id}`);
    }

    getMembership(id: number): Observable<Group[]> {
        return this.http.get<Group[]>(`${this.url}/membership/${id}`)
            .pipe(map(groupPage => groupPage['content']));
    }

    createDevice(request: Device): Observable<Device> {
        return this.http.post<Device>(this.url, request);
    }

    updateDevice(request: Device): Observable<Device> {
        return this.http.put<Device>(this.url, request);
    }

    deleteDevice(id: number): Observable<Device> {
        return this.http.delete<Device>(`${this.url}/${id}`);
    }

    getDevicesPage(page): Observable<Pageable<Device>> {
        return this.http.get<Pageable<Device>>(`api/v1/devices?size=${page.limit}&page=${page.offset}&sort=${page.orderBy}`);
    }

    getDevicesByOwnerPage(page, individualId: number): Observable<Pageable<Device>> {
        return this.http.get<Pageable<Device>>(`api/v1/devices/owner/${individualId}?&size=${page.limit}&page=${page.offset}&sort=${page.orderBy}`);
    }
}
